// @ts-nocheck
import { createAction } from '@reduxjs/toolkit';

export const toggleLoader = createAction('model/loaders/toggle', ({ component, isLoading }) => ({
	payload: {
		component,
		isLoading,
	},
}));

export const handleComponentStatus = createAction(
	'model/loaders/status',
	({ component, isLoading, status, message }) => ({
		payload: {
			component,
			isLoading,
			status,
			message,
		},
	})
);
